import React, { useState } from "react";
import { Container, Box, Typography, Avatar, AvatarGroup, Checkbox } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const initialTasks = [
  {
    id: 1,
    title: "Client Review & Feedback",
    project: "Crypto Wallet Redesign",
    time: "Today 10:00 PM - 11:45 PM",
    avatars: ["/avatar1.png", "/avatar2.png"], // Replace with real image URLs
    completed: false,
  },
  {
    id: 2,
    title: "Create Wireframe",
    project: "Crypto Wallet Redesign",
    time: "Today 09:15 PM - 10:00 PM",
    avatars: ["/avatar3.png", "/avatar4.png", "/avatar5.png"],
    completed: false,
  },
  {
    id: 3,
    title: "Review with Client",
    project: "Product Team",
    time: "Today 01:00 PM - 03:00 PM",
    avatars: ["/avatar6.png", "/avatar7.png"],
    completed: false,
  },
  {
    id: 4,
    title: "Ideation",
    project: "Product Team",
    time: "Today 09:15 PM - 10:00 PM",
    avatars: ["/avatar8.png"],
    completed: false,
  },
];

const TodoList = () => {
  const [tasks, setTasks] = useState(initialTasks);

  // Handle checkbox toggle
  const handleToggle = (id) => {
    setTasks((prevTasks) =>
      prevTasks.map((task) =>
        task.id === id ? { ...task, completed: !task.completed } : task
      )
    );
  };

  // Remove completed tasks
  const handleRemoveCompleted = () => {
    setTasks((prevTasks) => prevTasks.filter((task) => !task.completed));
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      {tasks.map((task) => (
        <Box
          key={task.id}
          sx={{
            display: "flex",
            flexDirection: "column",
            p: 2,
            mb: 2,
            borderRadius: 2,
            boxShadow: 2,
            bgcolor: "#fff",
            textDecoration: task.completed ? "line-through" : "none",
            opacity: task.completed ? 0.6 : 1,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {task.title}
            </Typography>
            <Checkbox
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckCircleOutlineIcon />}
              checked={task.completed}
              onChange={() => handleToggle(task.id)}
              sx={{ color: task.completed ? "blue" : "grey" }}
            />
          </Box>
          <Typography variant="body2" color="text.secondary">
            {task.project}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {task.time}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <AvatarGroup max={4}>
              {task.avatars.map((avatar, index) => (
                <Avatar key={index} src={avatar} />
              ))}
            </AvatarGroup>
          </Box>
        </Box>
      ))}
      {tasks.some((task) => task.completed) && (
        <Box textAlign="center" mt={2}>
          <Typography
            variant="body1"
            color="primary"
            sx={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={handleRemoveCompleted}
          >
            Remove Completed Tasks
          </Typography>
        </Box>
      )}
    </Container>
  );
};

export default TodoList;